const status = "Prod";
export const serverLink = status === "Dev" ? "http://localhost:4480/" : "https://backend.cosmopolitan.edu.ng:4480/";

export const projectName = "COSMOPOLITAN UNIVERSITY";
export const projectCode = "COSMOPOLITAN_UNIVERSITY";
export const serverStatus = status;
export const projectURL = "https://cosmopolitan.edu.ng/";
export const projectPhone = "+25767800004";
export const projectEmail = "info@cosmopolitan.edu.ng";
export const projectAddress = "Olivia University Bujumbura, № 4&5, Mayugi, Avenue, Mukaza, Bujumbura-Burundi";
export const projectFooter = "Copyright Olivia University, Burundi";
export const projectLogo = `${projectURL}logo.png`;

// SOCIAL MEDIA
export const projectFacebook = "https://www.facebook.com/";
export const projectTwitter = "https://www.twitter.com/";
export const projectInstagram = "https://instagram.com/?lang=en";
export const projectLinkedIn = "https://linkedin.com/?lang=en";
